if (!customElements.get('skeleton-loader')) {
    class SkeletonLoader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.closest('.skeleton-loader-container').style.display = 'none';
        }
    }

    customElements.define('skeleton-loader', SkeletonLoader);
}
